import Layout from '@/layout'
import LayoutView from '@/layout/layout'

export default {
	path: '/machinemanage',
	component: Layout,
	name: '设备管理',
	id: 202000,
	meta: {
		title: '设备',
		roles: [202000]
	},
	redirect: 'machinemanage',
	children: [
		{
			path: '',
			component: LayoutView,
			name: 'RFID自选餐线',
			id: 202060,
			meta: {
				title: 'RFID自选餐线',
				noCache: true,
				roles: [202060]
			},
			redirect: 'chupinji',
			children: [
				{
					path: 'chupinji-new',
					component: () =>
						import(
							/* webpackChunkName: "chupinji" */
							'@/leniuview/deviceMange/chupinji'
						),
					name: '出品机-new',
					id: 202061,
					meta: {
						title: '出品机-new',
						roles: [202061],
						noCache: true
					}
				},
				{
					path: 'can-transverter-new',
					component: () =>
						import(
							/* webpackChunkName: "chupinji" */
							'@/leniuview/deviceMange/can-transverter'
						),
					name: 'can转换器-new',
					id: 202061,
					meta: {
						title: 'can转换器-new',
						roles: [202061],
						noCache: true
					}
				},
				{
					path: 'chupinjiwg-new',
					component: () =>
						import(
							/* webpackChunkName: "chupinji" */
							'@/leniuview/deviceMange/chupinjiwg'
						),
					name: '数据网关-new',
					id: 202062,
					meta: {
						title: '数据网关-new',
						roles: [202061]
					}
				},
				{
					path: 'plchupinji-new',
					component: () =>
						import(
							/* webpackChunkName: "plchupinji" */
							'@/leniuview/deviceMange/plchupinji'
						),
					name: '批量出品机-new',
					id: 202150,
					meta: {
						title: '批量出品机-new',
						roles: [202150]
					}
				},
				{
					path: 'cantaimachine-new',
					component: () =>
						import(
							/* webpackChunkName: "cantaimachine" */
							'@/leniuview/deviceMange/cantaimachine'
						),
					name: '智慧餐台-new',
					id: 202050,
					meta: {
						title: '智慧餐台-new',
						roles: [202050]
					}
				},
				{
					path: 'chupinji',
					component: () =>
						import(
							/* webpackChunkName: "chupinji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/chupinji'
						),
					name: '出品机',
					id: 202061,
					meta: {
						title: '出品机',
						roles: [202061]
					}
				},
				{
					path: 'chupinjiwg',
					component: () =>
						import(
							/* webpackChunkName: "chupinji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/chupinjiwg'
						),
					name: '出品机网关',
					id: 202062,
					meta: {
						title: '出品机网关',
						roles: [202061]
					}
				},
				{
					path: 'chupinjiwgDetail',
					component: () =>
						import(
							/* webpackChunkName: "chupinji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/chupinjiwgDetail'
						),
					name: '网关详情',
					hidden: true,
					meta: {
						title: '网关详情',
						roles: [202061],
						noCache: true
					}
				},
				{
					path: 'plchupinji',
					component: () =>
						import(
							/* webpackChunkName: "plchupinji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/plchupinji'
						),
					name: '批量出品机',
					id: 202150,
					meta: {
						title: '批量出品机',
						roles: [202150]
					}
				},
				{
					path: 'cantaimachine',
					component: () =>
						import(
							/* webpackChunkName: "cantaimachine" */
							'@/leniuview/basesetting/machinemanage/newcomponents/cantaimachine'
						),
					name: '智慧餐台',
					id: 202050,
					meta: {
						title: '智慧餐台',
						roles: [202050]
					}
				}
			]
		},
		{
			path: '',
			component: LayoutView,
			name: '视觉自选餐线',
			id: 202090,
			meta: {
				title: '视觉自选餐线',
				noCache: true,
				roles: [202090]
			},
			redirect: 'dishidentification',
			children: [
				{
					path: 'AIcaipinshibie-new',
					component: () =>
						import(
							/* webpackChunkName: "AIcaipinshibie" */
							'@/leniuview/deviceMange/AIcaipinshibie'
						),
					name: 'AI菜品识别结算台-new',
					id: 202270,
					meta: {
						title: 'AI菜品识别结算台-new',
						roles: [202270]
					}
				},
				{
					path: 'AIcaipincaijizhongduan-new',
					component: () =>
						import(
							/* webpackChunkName: "AIcaipincaijizhongduan" */
							'@/leniuview/deviceMange/AIcaipincaijizhongduan'
						),
					name: 'AI菜品采集终端-new',
					id: 202280,
					meta: {
						title: 'AI菜品采集终端-new',
						roles: [202280]
					}
				},
				{
					path: 'dishidentification',
					component: () =>
						import(
							/* webpackChunkName: "dishidentification" */
							'@/leniuview/basesetting/machinemanage/newcomponents/dishidentification'
						),
					name: '菜品识别配置',
					id: 202091,
					meta: {
						title: '菜品识别配置',
						roles: [202091]
					}
				},
				{
					path: 'caipininfo',
					component: () =>
						import(
							/* webpackChunkName: "caipininfo" */
							'@/leniuview/basesetting/machinemanage/newcomponents/caipininfo'
						),
					name: '菜谱菜品详情',
					meta: { title: '菜谱菜品详情', noCache: true, roles: [202091] },
					hidden: true
				},
				{
					path: 'caipuinfo',
					component: () =>
						import(
							/* webpackChunkName: "caipuinfo" */
							'@/leniuview/basesetting/machinemanage/newcomponents/caipuinfo'
						),
					name: '全量菜谱详情',
					meta: { title: '全量菜谱详情', noCache: true, roles: [202091] },
					hidden: true
				},
				{
					path: 'menuaipicture',
					component: () =>
						import(
							/* webpackChunkName: "menuaipicture" */
							'@/leniuview/basesetting/machinemanage/newcomponents/menuaipicture'
						),
					name: '菜品详情照片',
					meta: { title: '菜品详情照片', noCache: true, roles: [202091] },
					hidden: true
				},
				{
					path: 'AIcaipinshibie',
					component: () =>
						import(
							/* webpackChunkName: "AIcaipinshibie" */
							'@/leniuview/basesetting/machinemanage/newcomponents/AIcaipinshibie'
						),
					name: 'AI菜品识别',
					id: 202270,
					meta: {
						title: 'AI菜品识别',
						roles: [202270]
					}
				},
				{
					path: 'AIcaipincaijizhongduan',
					component: () =>
						import(
							/* webpackChunkName: "AIcaipincaijizhongduan" */
							'@/leniuview/basesetting/machinemanage/newcomponents/AIcaipincaijizhongduan'
						),
					name: 'AI菜品采集终端',
					id: 202280,
					meta: {
						title: 'AI菜品采集终端',
						roles: [202280]
					}
				}
			]
		},
		{
			path: '',
			component: LayoutView,
			name: '计量自助餐',
			id: 202190,
			meta: {
				title: '计量自助餐',
				noCache: true,
				roles: [202190]
			},
			redirect: 'selfweighingchupinji',
			children: [
				{
					path: 'selfweighingchupinji-new',
					component: () =>
						import(
							/* webpackChunkName: "selfweighingchupinji" */
							'@/leniuview/deviceMange/selfweighingchupinji'
						),
					name: '计量主机-new',
					id: 202191,
					meta: {
						title: '计量主机-new',
						roles: [202191]
					}
				},
				{
					path: 'paicaipingban-new',
					component: () =>
						import(
							/* webpackChunkName: "paicaipingban" */
							'@/leniuview/deviceMange/paicaipingban'
						),
					name: '排菜平板-new',
					id: 202140,
					meta: {
						title: '排菜平板-new',
						roles: [202140]
					}
				},
				{
					path: 'androidbind-new',
					component: () =>
						import(
							/* webpackChunkName: "androidbind" */
							'@/leniuview/deviceMange/androidbind'
						),
					name: '取盘机-new',
					id: 202020,
					meta: {
						title: '取盘机-new',
						roles: [202020]
					}
				},
				{
					path: 'selfweighingchupinji',
					component: () =>
						import(
							/* webpackChunkName: "selfweighingchupinji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/selfweighingchupinji'
						),
					name: '计量主机',
					id: 202191,
					meta: {
						title: '计量主机',
						roles: [202191]
					}
				},
				{
					path: 'alarmInfo',
					component: () =>
						import('@/leniuview/personal/alarmInfo'),
					name: '报警信息',
					// id: 720000,
					// meta: { title: "报警信息", roles: [720000] }
					hidden: true,
					meta: { title: '报警信息', roles: [202191] }
				},
				{
					path: 'paicaipingban',
					component: () =>
						import(
							/* webpackChunkName: "paicaipingban" */
							'@/leniuview/basesetting/machinemanage/newcomponents/paicaipingban'
						),
					name: '排菜平板',
					id: 202140,
					meta: {
						title: '排菜平板',
						roles: [202140]
					}
				},
				{
					path: 'androidbind',
					component: () =>
						import(
							/* webpackChunkName: "androidbind" */
							'@/leniuview/basesetting/machinemanage/newcomponents/androidbind'
						),
					name: '安卓绑定机',
					id: 202020,
					meta: {
						title: '安卓绑定机',
						roles: [202020]
					}
				}
			]
		},
		{
			path: '',
			component: LayoutView,
			name: '自助点餐',
			id: 202070,
			meta: {
				title: '自助点餐',
				noCache: true,
				roles: [202070]
			},
			redirect: 'diancanji',
			children: [
				{
					path: 'diancanji-new',
					component: () =>
						import(
							/* webpackChunkName: "diancanji" */
							'@/leniuview/deviceMange/diancanji'
						),
					name: '自助点餐机-new',
					id: 202071,
					meta: {
						title: '自助点餐机-new',
						roles: [202071]
					}
				},
				{
					path: 'jiaohaoji-new',
					component: () =>
						import(
							/* webpackChunkName: "jiaohaoji" */
							'@/leniuview/deviceMange/jiaohaoji'
						),
					name: '叫号机-new',
					id: 202110,
					meta: {
						title: '叫号机-new',
						roles: [202110]
					}
				},
				{
					path: 'servicecounter-new',
					component: () =>
						import(
							/* webpackChunkName: "servicecounter" */
							'@/leniuview/deviceMange/servicecounter'
						),
					name: '生鲜柜-new',
					id: 202200,
					meta: {
						title: '生鲜柜-new',
						roles: [202200]
					}
				},
				{
					path: 'baowengui-new',
					component: () =>
						import(
							/* webpackChunkName: "servicecounter" */
							'@/leniuview/deviceMange/baowengui'
						),
					name: '保温柜-new',
					id: 202200,
					meta: {
						title: '保温柜-new',
						roles: [202200]
					}
				},
				{
					path: 'hexiaoji-new',
					component: () =>
						import(
							/* webpackChunkName: "hexiaoji" */
							'@/leniuview/deviceMange/hexiaoji'
						),
					name: '核销机-new',
					id: 202100,
					meta: {
						title: '核销机-new',
						roles: [202100]
					}
				},
				{
					path: 'diancanji',
					component: () =>
						import(
							/* webpackChunkName: "diancanji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/diancanji'
						),
					name: '点餐机',
					id: 202071,
					meta: {
						title: '点餐机',
						roles: [202071]
					}
				},
				{
					path: 'jiaohaoji',
					component: () =>
						import(
							/* webpackChunkName: "jiaohaoji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/jiaohaoji'
						),
					name: '叫号机',
					id: 202110,
					meta: {
						title: '叫号机',
						roles: [202110]
					}
				},
				{
					path: 'servicecounter',
					component: () =>
						import(
							/* webpackChunkName: "servicecounter" */
							'@/leniuview/basesetting/machinemanage/newcomponents/servicecounter'
						),
					name: '智能保温取餐柜',
					id: 202200,
					meta: {
						title: '智能保温取餐柜',
						roles: [202200]
					}
				},
				{
					path: 'detail',
					component: () =>
						import(
							/* webpackChunkName: "detail" */
							'@/leniuview/basesetting/machinemanage/detail'
						),
					name: '取餐柜详情',
					meta: { title: '取餐柜详情', roles: [202200] },
					hidden: true,
					noCache: true
				},
				{
					path: 'hexiaoji',
					component: () =>
						import(
							/* webpackChunkName: "hexiaoji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/hexiaoji'
						),
					name: '核销机',
					id: 202100,
					meta: {
						title: '核销机',
						roles: [202100]
					}
				}
			]
		},
		{
			path: '',
			component: LayoutView,
			name: '消费机',
			id: 202120,
			meta: {
				title: '消费机',
				noCache: true,
				roles: [202120]
			},
			redirect: 'xiaofeiji',
			children: [
				// {
				//   path: 'xiaofeiji',
				//   component: () =>
				//     import (
				//       /* webpackChunkName: "lishixiaofeiji" */
				//       '@/leniuview/basesetting/machinemanage/newcomponents/xiaofeiji'
				//     ),
				//   name: '消费机',
				//   id: 202121,
				//   meta: {
				//     title: '消费机',
				//     roles: [202121],
				//   },
				// },
				// {
				// 	path: 'xiaofeiji-new',
				// 	component: () =>
				// 		import(/* webpackChunkName: "xiaofeiji" */'@/leniuview/deviceMange/xiaofeiji'),
				// 	name: '消费机-new',
				// 	id: 202121,
				// 	meta: {
				// 		title: '消费机-new',
				// 		roles: [202121]
				// 	}
				// },
				{
					path: 'lishixiaofeiji-new',
					component: () =>
						import(
							/* webpackChunkName: "lishixiaofeiji" */
							'@/leniuview/deviceMange/lishixiaofeiji'
						),
					name: '立式消费机-new',
					id: 202121,
					meta: {
						title: '立式消费机-new',
						roles: [202121]
					}
				},
				{
					path: 'zhifupos-new',
					component: () =>
						import(
							/* webpackChunkName: "zhifupos" */ '@/leniuview/deviceMange/zhifupos'
						),
					name: '单屏消费机-new',
					id: 202260,
					meta: {
						title: '单屏消费机-new',
						roles: [202260]
					}
				},
				{
					path: 'shuangpingxiaofeiji-new',
					component: () =>
						import(
							/* webpackChunkName: "shuangpingxiaofeiji" */ '@/leniuview/deviceMange/shuangpingxiaofeiji'
						),
					name: '双屏消费机-new',
					id: 202220,
					meta: {
						title: '双屏消费机-new',
						roles: [202220]
					}
				},
				{
					path: 'androidchongzhi-new',
					component: () =>
						import(
							/* webpackChunkName: "androidchongzhi" */
							'@/leniuview/deviceMange/androidchongzhi'
						),
					name: '安卓自助充值机-new',
					id: 202030,
					meta: {
						title: '安卓自助充值机-new',
						roles: [202030]
					}
				},
				{
					path: 'androidguashiji-new',
					component: () =>
						import(
							/* webpackChunkName: "androidguashiji" */
							'@/leniuview/deviceMange/androidguashiji'
						),
					name: '挂式/台式机-new',
					id: 202040,
					meta: {
						title: '挂式/台式机-new',
						roles: [202040]
					}
				},
				{
					path: 'shouchiji-new',
					component: () =>
						import(
							/* webpackChunkName: "shouchiji" */
							'@/leniuview/deviceMange/shouchiji'
						),
					name: '手持机-new',
					id: 202210,
					meta: {
						title: '手持机-new',
						roles: [202210]
					}
				},
				{
					path: 'saomashoufeiji-new',
					component: () =>
						import(
							/* webpackChunkName: "saomashoufeiji" */
							'@/leniuview/deviceMange/saomashoufeiji'
						),
					name: '扫码收费机-new',
					id: 202180,
					meta: {
						title: '扫码收费机-new',
						roles: [202180]
					}
				},
				{
					path: 'lishixiaofeiji',
					component: () =>
						import(
							/* webpackChunkName: "lishixiaofeiji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/lishixiaofeiji'
						),
					name: '立式消费机',
					id: 202121,
					meta: {
						title: '立式消费机',
						roles: [202121]
					}
				},
				{
					path: 'zhifupos',
					component: () =>
						import(
							/* webpackChunkName: "zhifupos" */ '@/leniuview/basesetting/machinemanage/newcomponents/zhifupos'
						),
					name: '单屏消费机',
					id: 202260,
					meta: {
						title: '单屏消费机',
						roles: [202260]
					}
				},
				{
					path: 'shuangpingxiaofeiji',
					component: () =>
						import(
							/* webpackChunkName: "shuangpingxiaofeiji" */ '@/leniuview/basesetting/machinemanage/newcomponents/shuangpingxiaofeiji'
						),
					name: '双屏消费机',
					id: 202220,
					meta: {
						title: '双屏消费机',
						roles: [202220]
					}
				},
				{
					path: 'androidchongzhi',
					component: () =>
						import(
							/* webpackChunkName: "androidchongzhi" */
							'@/leniuview/basesetting/machinemanage/newcomponents/androidchongzhi'
						),
					name: '安卓自助充值机',
					id: 202030,
					meta: {
						title: '安卓自助充值机',
						roles: [202030]
					}
				},
				{
					path: 'androidguashiji',
					component: () =>
						import(
							/* webpackChunkName: "androidguashiji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/androidguashiji'
						),
					name: '挂式/台式机',
					id: 202040,
					meta: {
						title: '挂式/台式机',
						roles: [202040]
					}
				},
				{
					path: 'shouchiji',
					component: () =>
						import(
							/* webpackChunkName: "shouchiji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/shouchiji'
						),
					name: '手持机',
					id: 202210,
					meta: {
						title: '手持机',
						roles: [202210]
					}
				},
				{
					path: 'saomashoufeiji',
					component: () =>
						import(
							/* webpackChunkName: "saomashoufeiji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/saomashoufeiji'
						),
					name: '扫码收费机',
					id: 202180,
					meta: {
						title: '扫码收费机',
						roles: [202180]
					}
				}
			]
		},
		{
			path: '',
			component: LayoutView,
			name: '后厨设备',
			id: 202010,
			meta: {
				title: '后厨设备',
				noCache: true,
				roles: [202010]
			},
			redirect: 'AIcheng',
			children: [
				{
					path: 'AIcheng-new',
					component: () =>
						import(
							/* webpackChunkName: "AIcheng" */
							'@/leniuview/deviceMange/AIcheng'
						),
					name: 'AI秤-new',
					id: 202011,
					meta: {
						title: 'AI秤-new',
						roles: [202011]
					}
				},
				{
					path: 'liuyangji-new',
					component: () =>
						import(
							/* webpackChunkName: "liuyangji" */
							'@/leniuview/deviceMange/liuyangji'
						),
					name: '留样机-new',
					id: 202130,
					meta: {
						title: '留样机-new',
						roles: [202130]
					}
				},
				{
					path: 'dianzicaipai-new',
					component: () =>
						import(
							/* webpackChunkName: "dianzicaipai" */
							'@/leniuview/deviceMange/dianzicaipai'
						),
					name: '电子菜排-new',
					id: 202080,
					meta: {
						title: '电子菜排-new',
						roles: [202080]
					}
				},
				{
					path: 'AIcheng',
					component: () =>
						import(
							/* webpackChunkName: "AIcheng" */
							'@/leniuview/basesetting/machinemanage/newcomponents/AIcheng'
						),
					name: 'AI秤',
					id: 202011,
					meta: {
						title: 'AI秤',
						roles: [202011]
					}
				},
				{
					path: 'liuyangji',
					component: () =>
						import(
							/* webpackChunkName: "liuyangji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/liuyangji'
						),
					name: '留样机',
					id: 202130,
					meta: {
						title: '留样机',
						roles: [202130]
					}
				},
				{
					path: 'dianzicaipai',
					component: () =>
						import(
							/* webpackChunkName: "dianzicaipai" */
							'@/leniuview/basesetting/machinemanage/newcomponents/dianzicaipai'
						),
					name: '电子菜排',
					id: 202080,
					meta: {
						title: '电子菜排',
						roles: [202080]
					}
				},
				{
					path: 'uploadplate',
					component: () =>
						import(
							/* webpackChunkName: "uploadplate" */
							'@/leniuview/basesetting/machinemanage/uploadplate'
						),
					name: '上传空托盘',
					meta: { noCache: true, title: 'lnbasesetting.uploadplate', roles: [202010] },
					hidden: true,
					noCache: true
				}
			]
		},
		{
			path: 'pesticideResidueDetector-new',
			component: () =>
				import(
					/* webpackChunkName: "pesticideResidueDetector" */
					'@/leniuview/deviceMange/pesticideResidueDetector'
				),
			name: '农残检测仪-new',
			id: 202012,
			meta: {
				title: '农残检测仪-new',
				roles: [202012]
			}
		},
		{
			path: 'passengerFlowStatistics-new',
			component: () =>
				import(
					/* webpackChunkName: "passengerFlowStatistics" */
					'@/leniuview/deviceMange/passengerFlowStatistics'
				),
			name: '摄像机-new',
			id: 202013,
			meta: {
				title: '摄像机-new',
				roles: [202013]
			}
		},
		{
			path: 'pesticideResidueDetector',
			component: () =>
				import(
					/* webpackChunkName: "pesticideResidueDetector" */
					'@/leniuview/basesetting/machinemanage/newcomponents/pesticideResidueDetector'
				),
			name: '农残检测仪',
			id: 202012,
			meta: {
				title: '农残检测仪',
				roles: [202012]
			}
		},
		{
			path: 'passengerFlowStatistics',
			component: () =>
				import(
					/* webpackChunkName: "passengerFlowStatistics" */
					'@/leniuview/basesetting/machinemanage/newcomponents/passengerFlowStatistics'
				),
			name: '摄像机',
			id: 202013,
			meta: {
				title: '摄像机',
				roles: [202013]
			}
		},
		{
			path: '',
			component: LayoutView,
			name: '打印机',
			id: 202161,
			meta: {
				title: '其他',
				noCache: true,
				roles: [202161]
			},
			redirect: 'printmachine',
			children: [
				{
					path: 'printmachine-new',
					component: () =>
						import(
							/* webpackChunkName: "printmachine" */
							'@/leniuview/deviceMange/printmachine'
						),
					name: '打印机-new',
					id: 202161,
					meta: {
						title: '打印机-new',
						roles: [202161]
					}
				},
				{
					path: 'printTemplate',
					component: () =>
						import(
							/* webpackChunkName: "printmachine" */
							'@/leniuview/deviceMange/printTemplate'
						),
					name: '模板管理-new',
					id: 202161,
					meta: {
						title: '模板管理-new',
						roles: [202161]
					}
				},
				{
					path: 'tipsPrintTemplate',
					component: () =>
						import(
							/* webpackChunkName: "printmachine" */
							'@/leniuview/deviceMange/printTemplates/tipsTemplate'
						),
					name: '小票打印机模板-new',
					id: 202161,
					meta: {
						noCache: true,
						title: '小票打印机模板-new',
						roles: [202161]
					}
				},
				{
					path: 'labelsPrintTemplate',
					component: () =>
						import(
							/* webpackChunkName: "printmachine" */
							'@/leniuview/deviceMange/printTemplates/labelsTemplate'
						),
					name: '标签打印机模板-new',
					id: 202161,
					meta: {
						noCache: true,
						title: '标签打印机模板-new',
						roles: [202161]
					}
				}
			]
		},
		{
			path: '',
			component: LayoutView,
			name: '其他',
			id: 202160,
			meta: {
				title: '其他',
				noCache: true,
				roles: [202160]
			},
			redirect: 'printmachine',
			children: [
				// {
				// 	path: 'printmachine-new',
				// 	component: () =>
				// 		import(
				// 			/* webpackChunkName: "printmachine" */
				// 			'@/leniuview/deviceMange/printmachine'
				// 		),
				// 	name: '打印机-new',
				// 	id: 202161,
				// 	meta: {
				// 		title: '打印机-new',
				// 		roles: [202161]
				// 	}
				// },
				{
					path: 'shuikongji-new',
					component: () =>
						import(
							/* webpackChunkName: "shuikongji" */
							'@/leniuview/deviceMange/shuikongji'
						),
					name: '水控机-new',
					id: 202230,
					meta: {
						title: '水控机-new',
						roles: [202230]
					}
				},
				{
					path: 'ufaceshibieji-new',
					component: () =>
						import(
							/* webpackChunkName: "ufaceshibieji" */
							'@/leniuview/deviceMange/ufaceshibieji'
						),
					name: '人脸识别终端-new',
					id: 202250,
					meta: {
						title: '人脸识别终端-new',
						roles: [202250]
					}
				},
				{
					path: 'releaseInformation-new',
					component: () =>
						import(
							/* webpackChunkName: "releaseInformation" */
							'@/leniuview/deviceMange/releaseInformation'
						),
					name: '信息发布屏-new',
					id: 202170,
					meta: {
						title: '信息发布屏-new',
						roles: [202170]
					}
				},
				{
					path: 'nutritionPriceTags-new',
					component: () =>
						import(
							/* webpackChunkName: "nutritionPriceTags" */
							'@/leniuview/deviceMange/nutritionPriceTags'
						),
					name: '营养价签-new',
					id: 202162,
					meta: {
						title: '营养价签-new',
						roles: [202162]
					}
				},
				{
					path: 'nutritionPriceTagsControl-new',
					component: () =>
						import(
							/* webpackChunkName: "nutritionPriceTagsControl" */
							'@/leniuview/deviceMange/nutritionPriceTagsControl'
						),
					name: '营养价签控制机-new',
					id: 202163,
					meta: {
						title: '营养价签控制机-new',
						roles: [202163]
					}
				},
				{
					path: 'printmachine',
					component: () =>
						import(
							/* webpackChunkName: "printmachine" */
							'@/leniuview/basesetting/machinemanage/newcomponents/printmachine'
						),
					name: '打印机',
					id: 202161,
					meta: {
						title: '打印机',
						roles: [202161]
					}
				},
				{
					path: 'shuikongji',
					component: () =>
						import(
							/* webpackChunkName: "shuikongji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/shuikongji'
						),
					name: '水控机',
					id: 202230,
					meta: {
						title: '水控机',
						roles: [202230]
					}
				},
				{
					path: 'ufaceshibieji',
					component: () =>
						import(
							/* webpackChunkName: "ufaceshibieji" */
							'@/leniuview/basesetting/machinemanage/newcomponents/ufaceshibieji'
						),
					name: '人脸识别终端',
					id: 202250,
					meta: {
						title: '人脸识别终端',
						roles: [202250]
					}
				},
				{
					path: 'registRecord',
					component: () =>
						import('@/leniuview/basesetting/othersetting/registRecord'),
					name: '注册记录',
					meta: {
						title: '注册记录',
						roles: [202250],
						noCache: true
					},
					hidden: true
				},
				{
					path: 'releaseInformation',
					component: () =>
						import(
							/* webpackChunkName: "releaseInformation" */
							'@/leniuview/basesetting/machinemanage/newcomponents/releaseInformation'
						),
					name: '信息发布屏',
					id: 202170,
					meta: {
						title: '信息发布屏',
						roles: [202170]
					}
				},
				{
					path: 'tablewaremanage',
					component: () =>
						import(
							'@/leniuview/basesetting/machinemanage/newcomponents/tablewaremanage'
						),
					name: '餐具管理',
					id: 202240,
					meta: {
						title: '餐具管理',
						roles: [202240]
					}
				},
				{
					path: 'zhuceinfo',
					component: () =>
						import(
							/* webpackChunkName: "zhuceinfo" */
							'@/leniuview/basesetting/machinemanage/newcomponents/zhuceinfo'
						),
					name: '注册信息',
					meta: { title: '注册信息', roles: [202091], noCache: true },
					hidden: true
				},
				{
					path: 'dsrecord',
					component: () =>
						import(
							/* webpackChunkName: "dsrecord" */
							'@/leniuview/basesetting/machinemanage/newcomponents/dsrecord'
						),
					name: '数据同步记录',
					meta: {
						title: '数据同步记录',
						roles: [202091]
					},
					hidden: true
				},
				{
					path: 'nutritionPriceTags',
					component: () =>
						import(
							/* webpackChunkName: "nutritionPriceTags" */
							'@/leniuview/basesetting/machinemanage/newcomponents/nutritionPriceTags'
						),
					name: '营养价签',
					id: 202162,
					meta: {
						title: '营养价签',
						roles: [202162]
					}
				},
				{
					path: 'nutritionPriceTagsControl',
					component: () =>
						import(
							/* webpackChunkName: "nutritionPriceTagsControl" */
							'@/leniuview/basesetting/machinemanage/newcomponents/nutritionPriceTagsControl'
						),
					name: '营养价签控制机',
					id: 202163,
					meta: {
						title: '营养价签控制机',
						roles: [202163]
					}
				},
				{
					path: 'HeightweightScale',
					component: () =>
						import(
							/* webpackChunkName: "HeightweightScale" */
							'@/leniuview/basesetting/machinemanage/newcomponents/HeightweightScale'
						),
					name: '身高体重秤',
					id: 202164,
					meta: {
						title: '身高体重秤',
						roles: [202164]
					}
				}
			]
		},
		{
			path: 'device-log',
			component: () =>
				import(
					/* webpackChunkName: "printmachine" */
					'@/leniuview/basesetting/machinemanage/newcomponents/device-log'
				),
			name: '设备日志',
			id: 202400,
			meta: {
				title: '设备日志',
				noCache: true,
				roles: [202400]
			}
		}
	]
}
